import axios from 'axios'

const state = {
  promotions: null,
  selectedPromotionIds: []
}

const actions = {
  LOAD_PROMOTIONS: async ({commit}, queryData) => {
    commit('SET_PROMOTIONS', [])
    let {data} = await axios.get('promotions', queryData)
    if (!data.error) {
      commit('SET_PROMOTIONS', data.promotions)
    }
  }
}

const mutations = {
  SET_PROMOTIONS: (state, promotions) => {
    state.promotions = promotions
  },
  SET_SELECTED_PROMOTION_IDS: (state, value) => {
    if (value === null) {
      state.selectedPromotionIds = []
    } else {
      if (state.selectedPromotionIds.indexOf(value) === -1) {
        state.selectedPromotionIds.push(value)
      }
    }
  }
}

const getters = {
  getState: state => {
    return state
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/promotion.js